import React from "react";
import BlogPost from "../features/blog/BlogPost";

function BlogPostPage() {
window.scrollTo(0, 0);
return (<BlogPost/>)
}

export default BlogPostPage;
